import React from "react"
import { DadosPedidoFornecedorContextProvider } from "./context/DadosPedidoFornecedorContextProvider"
import { DadosPedidoFornecedor } from "./DadosPedidoFornecedor"

export function Index() {
    return (
        <DadosPedidoFornecedorContextProvider>
            <DadosPedidoFornecedor />
        </DadosPedidoFornecedorContextProvider>
    )
}
